import React from "react";
import BackgroundImage from 'gatsby-background-image'
import { graphql, useStaticQuery } from 'gatsby';
import withStyles from "@material-ui/core/styles/withStyles";

const styles = {
  width: "100%",
  backgroundPosition: "center center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  width: "100%",
  minHeight: "150px"
}

function GirlAndNyse({...props}) {
    const {
      className,
      imageUrl,
      children,
      style
    } = props;
    const data = useStaticQuery(
      graphql`
        query {
          desktop: file(relativePath: { eq: "girl-nyse.jpg" }) {
            childImageSharp {
              fluid(quality: 90, maxWidth: 600) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      `
    );

    // Set ImageData.
    const imageData = data.desktop.childImageSharp.fluid;

    return (
      <BackgroundImage 
      Tag="div"
      role="img"
      aria-label="A girl standing in front of the New York Stock Exchange."
      className={className}
      fluid={imageData}
      style={{...styles, ...style}}
      >
        {children}
      </BackgroundImage>
    )
  }

export default withStyles(styles)(GirlAndNyse)